import React, { useEffect, useState } from "react";
import { withRouter, Link, useLocation } from "react-router-dom";
import DataTableComponent from "../../../../../../Util/DataTable/DataTable";
import { config, PERMISSIONS } from "../../../../../../config";
import { messages } from "../../../../../../messages";
import Popup from 'reactjs-popup';
import "./LeagueGroups.css"
import UserInfo from "./modals/UserInfo.js";
import { useParams } from 'react-router-dom';
import axiosApi from "../../../../../../core/interceptor/interceptor";
import { capitaLizeString, TEAM_STATUS, PREFERRED_TIME, loadColumns, generateDropList, PAYMENT_STATUS, getUrlToPush, PaymentTypeLabel, RegisteredBy, REFUNDED_STATUS } from "../../../../../../Util/helper";
import WarningDialogue from '../../../../../../Util/WarningDialogue';
import { useHistory } from "react-router-dom";
import MoveLeagueModal from './modals/MoveLeagueModal';
import back from "../../../../../../assets/arrow-back.svg";
import CustomSelect from "../../../../../../Util/CustomSelect/CustomSelect";
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { permissions } from "../../../../../../Store/reducers/PermissionsReducer";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import { toast } from "react-toast";


function TeamInfo(props) {
  const columns = [
    {
      name: 'Player',
      selector: 'full_name',
      type: 'registered_through',
      sortable: false,
    },
    {
      name: 'Gender',
      selector: 'gender',
      type: 'gender',
      sortable: false,
    },
    {
      name: 'Email',
      selector: 'email',
      sortable: false,
    },
    {
      name: 'Captain',
      selector: 'isCaptain',
      type: 'checked-i',
      sortable: false,
    },
    {
      name: 'Primary Phone',
      selector: 'cell_phone',
      type: 'contact_number',
      sortable: false,
    },
    {
      name: 'Secondary Phone',
      selector: 'secondary_phone',
      type: 'contact_number',
      sortable: false,
    },
    {
      name: 'Type',
      selector: 'player_type',
      type: 'player_type',
      sortable: false,
    },
    {
      name: 'Payment Status',
      selector: 'player_payment_status',
      type: 'player_payment_status',
      sortable: false,
    },
    {
      name: 'Paid By',
      selector: 'player_payment_type',
      type: 'player_payment_type',
      sortable: false,
      markPaid: (e) => markPaid(e)
    }
  ];
  const permission = useSelector(permissions);
  const history = useHistory();
  const [teamInfo, setTeamInfo] = useState({
    captain_id: 0,
    comment: '',
    created_at: '',
    created_by: 0,
    custom_option: '',
    failed_reason: '',
    imported_from: '',
    payment_status: '',
    players: [],
    preferred_time: '',
    status: '',
    transaction_id: 0
  });
  const [formData, setFormData] = useState({ name: '', comment: '', status: '', payment_status: '', total_fees: '', reg_fees: '', for_feit_fees: '' });
  const [playerData, setPlayerData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [userData, setUserData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [openMoveLeague, setOpenMoveLeague] = useState(false);
  const [leagueSeason, setLeagueSeason] = useState(null);
  const [paymentMessagepopup, setPaymentMessage] = useState(false);
  const [leagueScheduleCount, setLeagueScheduleCount] = useState(0);
  const closeModal = () => {
    setOpen(false);
    setOpenMoveLeague(false);
  }
  const [popUpContent, setPopUpContent] = useState({});
  const [playerDetail, setPlayerDtail] = useState({
    direction: 'desc',
    sort_column: '',
    page: 1,
    limit: 50,
  });

  const teamId = useParams().id;
  const leagueId = useParams().league_id;
  const [addEditTeamPerm, setAddEditTeamPerm] = useState(false);
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');
  const getTeamInfo = () => {
    axiosApi.get(`${config.apiUrl}/teams/${teamId}`)
      .then((response) => {
        let data = response.data.data;
        setTeamInfo(response.data.data);
        let formDataVal = {};
        formDataVal['name'] = data['name'];
        formDataVal['comment'] = data['comment'];
        formDataVal['status'] = data['status'];
        formDataVal['payment_status'] = data['payment_status'];
        formDataVal['for_feit_fees'] = data['for_feit_fees'];
        formDataVal['refund_amount'] = parseFloat(+data['refund_amount']) ? data['refund_amount'] / 100 : 0;
        formDataVal['is_refunded'] = data['is_refunded'] ? 1 : 0;
        formDataVal['total_fees'] = data['total_fees'];
        formDataVal['reg_fees'] = data?.league?.reg_fees || 0;
        formDataVal['for_feit_fees'] = data?.league?.for_feit_fees || 0;
        setFormData(formDataVal);
      })
      .catch((err) => {

      })
      .finally(() => {

      });
  }

  const getPlayerInfo = () => {
    axiosApi.get(`${config.apiUrl}/teams/players/${teamId}`, {
      params: playerDetail
    })
      .then((response) => {
        const data = response.data.data || [];
        data.forEach(x => x.isCaptain = x.id === teamInfo.captain_id)
        setPlayerData(data);
        setTotalPage(response.data.total);
      })
      .catch((err) => {

      })
      .finally(() => {

      });
  }

  const setStatus = (val, type) => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      [type]: val,
    }));
  }


  /**** Payment Confirmation ****/
  const showPaymentConfirmation = () => {
    setOpenWarningPopup(true);
    setPaymentMessage(true);
    let description = messages.chargeTeam.replace('{amount}', teamInfo.total_fees);
    setPopUpContent({
      header: 'Confirm',
      payment: true,
      description: description,
      icon: faExclamationTriangle,
      cancelButton: 'Cancel',
      confirmButton: 'Confirm',
      action: () => {
        formData.charge_user = true;
        formData.total_fees = teamInfo.total_fees;
        formData.stripe_payment_token = teamInfo.stripe_payment_token;
        formData.payment_status = 'paid';
        setFormData(formData);
        setOpenWarningPopup(false);
        setPaymentMessage(false);
        setTimeout(() => {
          handleSubmit();
        }, 100);
      },
      cancel: (status) => {
        setOpenWarningPopup(false);
        closePaymentWarning(true);
      }
    });

  }

  const sendPaymentLink = () => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Confirm',
      payment: false,
      description: 'Are you sure want to send payment link to customer?',
      icon: faExclamationTriangle,
      cancelButton: 'Cancel',
      confirmButton: 'Confirm',
      action: (confirm) => {
        axiosApi.post(`${config.apiUrl}/teams/send-payment-email`, {
          id: teamId,
          type: 'team',
        }).then((res) => {
          setOpenWarningPopup(false);
          getTeamInfo();
        })
      },
      cancel: () => {
        setOpenWarningPopup(false);
      }
    });
  }
  const closePaymentWarning = (status) => {
    if (status) {
      delete formData.charge_user;
      delete formData.total_fees;
      delete formData.stripe_payment_token;
      setFormData(formData);
      setTimeout(() => {
        handleSubmit();
      }, 100);
    }
    setPaymentMessage(false);
  }

  /***** Triggers when form data changes ******/
  const handleFormChange = (event) => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      [event.target.name]: event.target.value,
    }))
  }

  const handleSubmit = () => {
    if (parseFloat(+formData.refund_amount)) {
      formData.refund_amount = +formData.refund_amount * 100;
    }

    axiosApi.put(`${config.apiUrl}/teams/${teamId}`, formData)
      .then((res) => {
        if (res.data?.status === 'success') {
          if (formData.charge_user) {
            delete formData.charge_user;
            delete formData.total_fees;
            delete formData.stripe_payment_token;
  
            setFormData(formData);
          }
        } else if (res.data?.status === 'error' && res.data?.message){
          toast.error(res.data?.message)
        }
        getTeamInfo();
      })
      .catch((error) => {
        closeModal();
        getTeamInfo();
      });
  }

  // Check payment status
  const checkPaymentComplete = () => {
    if (formData.status == 'active' &&
      teamInfo.status == 'waiting' &&
      teamInfo.registered_by == 'user' &&
      teamInfo.payment_status == 'unpaid' &&
      teamInfo.pending_payment == '1' &&
      teamInfo.paid_by != 'cheque') {
      showPaymentConfirmation();
    } else {
      handleSubmit();
    }
  }


  const getLeagueAndSeasonInfo = () => {
    axiosApi.get(
      `${config.apiUrl}/misc/league/season/info/${leagueId}`
    ).then(
      (response) => {
        let data = response.data.data;
        setLeagueSeason(data);
      }
    )
  }

  useEffect(() => {
    getTeamInfo();
    if (props.from === 'individual_registration') {
      getLeagueAndSeasonInfo();
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (Array.isArray(permission)) {
      setAddEditTeamPerm(permission.includes(PERMISSIONS.TEAM_MODIFICATIONS));
    }
  }, [permission]);

  useEffect(() => {
    getPlayerInfo();
    //eslint-disable-next-line
  }, [
    playerDetail.page,
    playerDetail.limit,
    playerDetail.direction,
    playerDetail.sort_column,
    teamInfo,
  ])

  useEffect(() => {
    getScheduleStatus();
  }, [])

  const getScheduleStatus = () => {
    axiosApi.get(`${config.apiUrl}/teams/schedule/status/${leagueId}`)
      .then((response) => {
        setLeagueScheduleCount(response.data.data)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const deleteTeam = () => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Delete',
      description: leagueScheduleCount && leagueScheduleCount > 0 ? messages.deleteTeamWithOrWithoutSchedule : messages.deleteTeam,
      icon: faExclamationTriangle,
      cancelButton: 'Delete Without Schedule',
      confirmButton: 'Delete With Schedule',
      action: () => {
        if (leagueScheduleCount && leagueScheduleCount > 0) {
          checkProperSchedule();
        } else {
          removeTeam();
        }
      },
      cancel: () => {
        if (leagueScheduleCount && leagueScheduleCount > 0) {
          removeTeam();
        } else {
          setOpenWarningPopup(false);
        }
      }
    });
  }

  const checkProperSchedule = () => {
    setOpenWarningPopup(false);
    axiosApi.get(`${config.apiUrl}/teams/check/scheduling/${leagueId}?action=remove`)
      .then((response) => {
        if (!response.data.properScheduling) {
          setOpenWarningPopup(true);
          setPopUpContent({
            header: 'Confirm',
            description: response.data.message,
            icon: faExclamationTriangle,
            action: () => {
              setOpenWarningPopup(false);
              setTimeout(() => {
                history.push({
                  pathname: `/admin/leagues/teams/league-settings`,
                  search: `?leagueId=${leagueId}&selected=true${(season_id) ? `&season_id=${season_id}` : ''}`,
                })
              }, 100);
            },
            cancel: () => {
              setOpenWarningPopup(false);
            }
          });
        } else {
          removeTeam(true);
        }
      })
      .catch((err) => {
        removeTeam(true);
      })

  }

  const removeTeam = (schedule = false) => {
    axiosApi.delete(`${config.apiUrl}/teams/${teamId}/${schedule}`)
      .then((res) => {
        setOpenWarningPopup(false);
        if (res.data && res.data.conflicts) {
          setOpenWarningPopup(true);
          setPopUpContent({
            header: 'Warning',
            description: messages.conflictedFields,
            icon: faExclamationTriangle,
            action: () => {
              setOpenWarningPopup(false);
              setTimeout(() => {
                history.push({
                  pathname: `/admin/leagues/teams/weekly-match`,
                  search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}&selected=true` : ''}`,
                })
              }, 100);
            },
            cancel: () => {
              setOpenWarningPopup(false);
              setTimeout(() => {
                history.push({
                  pathname: `/admin/leagues/teams/weekly-match`,
                  search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}&selected=true` : ''}`,
                })
              }, 100);
            }
          });
        } else {
          history.push({
            pathname: getUrlToPush('league_groups'),
            search: `?leagueId=${leagueId}`
          });
        }
      })
      .catch((error) => {
        setOpenWarningPopup(false);
      });
  }

  const handleChange = (e) => {
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
      })
    }
    setPlayerDtail(stateFunc);
  }
  const openPlayer = (data) => {
    setOpen(o => !o);
    setUserData(data);
  }

  const reloadPage = (e) => {
    if (e) {
      getTeamInfo();
      getPlayerInfo();
    }
  }

  const markPaid = (id) => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Confirm',
      description: 'Are sure you want to mark payment as paid?',
      icon: faExclamationTriangle,
      cancelButton: 'Cancel',
      confirmButton: 'Confirm',
      action: () => {
        axiosApi.post(`${config.apiUrl}/teams/individualList/mark-paid/`, {
          id
        }).then((response) => {
          setOpenWarningPopup(false);
          const temp = [...playerData];
          const player = temp.find(x => x.individual_registration.id === id);
          if (player) {
            player.individual_registration.payment_status = 'paid';
            setPlayerData(temp);
          }
        })
        .catch((err) => {
    
        });
      },
      cancel: (status) => {
        setOpenWarningPopup(false);
      }
    });
  }


  return (
    <>
      <div className="content-wrapper TeamInfo-wrapper">
        <div className="heading-wrapper">
          <Link to={{
            pathname: props.backLink ? props.backLink : `/admin/leagues/teams`,
            search: `?leagueId=${leagueId}${season_id ? `&season_id=${season_id}` : ''}`
          }}><button className="primary-btn back-btn"> <img src={back} alt='back-icon' />{props.backLink ? 'Back to All Teams' : 'Back to League'}</button></Link>

          <div className="header-blk">
            <h2>{props.from ? capitaLizeString(props.from) : teamInfo && teamInfo['name']}</h2>
            <p>{props.from ? `${teamInfo && teamInfo['name']} - ${leagueSeason && leagueSeason.season.name} ${leagueSeason && leagueSeason.name}` : `Play time preference: ${PREFERRED_TIME[teamInfo && teamInfo['preferred_time']]}`}</p>
          </div>
        </div>
        <div className="inner-blk">
          <div className="team-main-card">
            <div className="team-card-block">
              <h2>Team Info</h2>
              <div className="input-group">
                <div className="input-field">
                  <label>Team Name</label>
                  <input className="primary-input"
                    type="text"
                    placeholder="Enter Team Name."
                    value={formData.name}
                    name='name'
                    onChange={handleFormChange}
                    disabled={!addEditTeamPerm}
                  />
                </div>
                {
                  addEditTeamPerm
                    ? <CustomSelect
                      key={'sports-key'}
                      data={generateDropList(TEAM_STATUS)}
                      label="Team Status"
                      placeholder={formData.status ? TEAM_STATUS[formData.status] : 'Select status'}
                      type="team_status"
                      onSelect={(e) => e && e.id && setStatus(e.id, 'status')}
                      selector="title" />
                    : <div className="input-field">
                      <label>Team Status</label>
                      <input className="primary-input"
                        type="text"
                        placeholder="Team Status."
                        value={TEAM_STATUS[formData.status]}
                        name='name'
                        disabled={!addEditTeamPerm} /></div>
                }
                <div className="input-field comments-field">
                  <label>Comments</label>
                  <input className="primary-input"
                    type="text"
                    placeholder="Add a Comment."
                    value={formData.comment ? formData.comment : ''}
                    name='comment'
                    onChange={handleFormChange}
                    disabled={!addEditTeamPerm}
                  />
                </div>
                {/* <div className="input-field comments-field">
                <label>Forfeit Fee</label>
                <input className="primary-input"
                  type="text"
                  placeholder="Forfiet Fee."
                  value={formData.for_feit_fees ? formData.for_feit_fees : 0}
                  name='for_feit_fees'
                  onChange={handleFormChange}
                  disabled={!addEditTeamPerm}
                />
              </div> */}
                <CustomSelect
                    key={'payment-key-1'}
                    data={[]}
                    label="Registered By"
                    placeholder={teamInfo.registered_by ? RegisteredBy[teamInfo.registered_by] : ''}
                    onSelect={(e) => { }}
                    selector="title"
                    disabled={true}
                  />
              </div>
            </div>
            <div className="team-card-block no-border">
              <h2>Payment Info</h2>
              <div className="input-group payment-team-block">
                <div className="input-field">
                  <label>Registration Fees</label>
                  <NumberFormat
                    placeholder=" "
                    onValueChange={(e) => handleFormChange({ target: { name: 'reg_fees', value: e.floatValue } })}
                    value={formData?.reg_fees}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    thousandsGroupStyle={['thousand']}
                    thousandSeparator={true}
                    disabled={true}
                    prefix='$'
                    name="reg_fees"
                    autoComplete="off"
                    className="primary-input input-no"
                  />
                </div>
                <div className="input-field">
                  <label>Paid Amount</label>
                  <NumberFormat
                    placeholder=" "
                    onValueChange={(e) => handleFormChange({ target: { name: 'total_fees', value: e.floatValue } })}
                    value={formData?.total_fees}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    thousandsGroupStyle={['thousand']}
                    thousandSeparator={true}
                    disabled={teamInfo?.paid_by === 'card' ? true : false}
                    prefix='$'
                    name="total_fees"
                    autoComplete="off"
                    className="primary-input input-no"
                  />
                </div>
                <CustomSelect
                  key={'payment-key-2'}
                  data={[]}
                  label="Paid Method"
                  placeholder={teamInfo.paid_by ? PaymentTypeLabel[teamInfo.paid_by] : ''}
                  onSelect={(e) => { }}
                  selector="title"
                  disabled={true}
                />

                {
                    addEditTeamPerm ? <CustomSelect
                      key={'payment-key-3'}
                      data={generateDropList(PAYMENT_STATUS)}
                      label="Payment Status"
                      placeholder={formData.payment_status ? PAYMENT_STATUS[formData.payment_status] : 'Select status'}
                      type="team_status"
                      onSelect={(e) => e && e.id && setStatus(e.id, 'payment_status')}
                      selector="title"
                      disabled={teamInfo?.paid_by === 'card' ? true : false}
                    />
                      : <div className="input-field">
                        <label>Payment Status</label>
                        <input className="primary-input"
                          type="text"
                          placeholder="Payment Status."
                          value={PAYMENT_STATUS[formData.payment_status]}
                          name='name'
                          disabled={!addEditTeamPerm} /></div>
                  }
              </div>
              <div className="input-group">
                <div className="input-field">
                  <label>Forfeit Fees</label>
                  <NumberFormat
                    placeholder=" "
                    onValueChange={(e) => handleFormChange({ target: { name: 'for_feit_fees', value: e.floatValue } })}
                    value={formData?.for_feit_fees}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    thousandsGroupStyle={['thousand']}
                    thousandSeparator={true}
                    disabled={true}
                    prefix='$'
                    name="for_feit_fees"
                    autoComplete="off"
                    className="primary-input input-no"
                  />
                </div>
                { }
                <CustomSelect
                  key={'forfeit-refunded'}
                  data={generateDropList(REFUNDED_STATUS)}
                  label="Forfeit Refunded"
                  placeholder={formData.is_refunded ? REFUNDED_STATUS[formData.is_refunded] : REFUNDED_STATUS[0]}
                  onSelect={(e) => e && e.id && setStatus(+e.id, 'is_refunded')}
                  selector="title"
                  disabled={true}
                />
                <div className="input-field">
                  <label>Refunded Forfeit Fee</label>
                  <input className="primary-input"
                    type="text"
                    placeholder="Refunded Forfiet Fee."
                    value={formData.refund_amount ? formData.refund_amount : 0}
                    name='refund_amount'
                    onChange={handleFormChange}
                    disabled={!addEditTeamPerm}
                  />
                </div>
              </div>
            </div>
            
            {addEditTeamPerm &&
            <div className="btn-ui-block">
              <button className="primary-btn" onClick={() => checkPaymentComplete()}>Save Changes</button>
              {
                teamInfo.show_payment_button && teamInfo.pending_payment === '1' && (
                <>
                  <button className="primary-btn" onClick={() => sendPaymentLink()}>{teamInfo.payment_hash_time ? 'Resend Payment Link' : 'Send Payment Link'}</button>
                  <span className="waiting-payment-note"> Note: { teamInfo.failed_code === 'authentication_required' ? 'The payment got failed as the card was 3-D secure. So, please receive the payment manually from the user': teamInfo.failed_reason }</span>
                  <span className="">To send user payment link, please click on the "Send payment link" button.</span> 
                </>
                )
              }

              {
                teamInfo.status == 'waiting' &&
                teamInfo.registered_by == 'user' &&
                teamInfo.payment_status == 'unpaid' &&
                teamInfo.pending_payment == '1' &&
                teamInfo.paid_by != 'cheque' &&
                !teamInfo.show_payment_button && (
                  <span className="waiting-payment-note"> Note: Payment of ${teamInfo.total_fees} will deducted from user's card when status changed to "Active" .</span>
                )
              }
            </div>
          }
          </div>


          <Popup open={open} closeOnDocumentClick onClose={closeModal}>
            <UserInfo data={userData} team={teamInfo['name']} captainId={teamInfo['captain_id']} teamId={teamId} closeModel={(e) => { setOpen(o => !o); reloadPage(e); }} />
          </Popup>
          <Popup className="overflow-visible" open={openMoveLeague} closeOnDocumentClick onClose={closeModal}>
            <MoveLeagueModal closeModal={(e) => { setOpenMoveLeague(o => !o) }} teamId={teamId} leagueId={leagueId} leagueName={teamInfo['name']} />
          </Popup>
        </div>
        <div className="table-wrapper">
          <div className="heading-blk">
            <div className="left">
              <h2>Players</h2>
              {addEditTeamPerm && <p>Select a player to modify</p>}
            </div>
          </div>
          <div className="dataTable">
            <DataTableComponent key="table-admin-users" type={'teamPlayer'} data={playerData} onFilterChange={handleChange}
              columns={loadColumns({ columns })} totalPage={totalPage} openPlayer={(data) => openPlayer(data)} />
          </div>
        </div>
        <div className="button-blk">
          <div className="left">
            {addEditTeamPerm && <Link to={props.from ? `/admin/leagues/individual-registrations/TeamInfo/add/${leagueId}/${teamId}` : `/admin/leagues/LeagueGroups/TeamInfo/add/${leagueId}/${teamId}${season_id ? `?season_id=${season_id}` : ''}`}><button className="primary-btn">Add a Player</button></Link>}
            {permission.includes(PERMISSIONS.LEAGUE_MODIFICATIONS) && <button className="primary-btn" onClick={() => { setOpenMoveLeague(o => !o) }}>Move Team</button>}
          </div>
          <div className="right">
            {addEditTeamPerm && <button className="primary-btn delete-btn" onClick={() => deleteTeam()}>Delete Team</button>}
          </div>
        </div>
      </div>
      <WarningDialogue
        isOpen={openWarningPopup}
        header={popUpContent.header}
        description={popUpContent.description}
        paymentWarning={popUpContent.payment}
        icon={popUpContent.icon}
        cancelButton={popUpContent.cancelButton}
        confirmButton={popUpContent.confirmButton}
        action={popUpContent.action}
        onClose={popUpContent.cancel}
      />
    </>
  );
}

export default withRouter(TeamInfo);

